import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMapPin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 11 15",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.75 14.15C6.75 14.15 6.15 15 5.55 15C4.95 15 4.35 14.15 4.35 14.15C4.35 14.15 1 9.25 0.4 6.9C0.1 6.35 0 5.75 0 5.2C0 2.3 2.45 0 5.5 0C8.55 0 11 2.3 11 5.2C11 5.8 10.9 6.35 10.7 6.9C10.1 9.25 6.75 14.15 6.75 14.15ZM5.5 3.2C4.4 3.25 3.55 4.25 3.6 5.35C3.65 6.45 4.65 7.3 5.75 7.25C6.8 7.2 7.65 6.3 7.65 5.2C7.6 4.05 6.65 3.15 5.5 3.2Z" })
});
export default SvgIconMapPin;
